export const  excludedFileFormats = [
    'exe',
    'bat',
    'cmd',
    'msi',
    'com',
    'jar',
    'bin',
    'sys',
    'dll',
    'drv',
    'ocx',
    'wsf',
    'wsh',
    'svg'
  ];